import { useState, useRef } from 'react';

const useUIState = () => {
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [notification, setNotification] = useState(null);
    const [isLimiterActive, setIsLimiterActive] = useState(false);
    const [limiterBudget, setLimiterBudget] = useState(100);

    // Ref for persistence state that shouldn't trigger re-renders
    const isRestoring = useRef(false);

    return {
        loading, setLoading,
        isModalOpen, setIsModalOpen,
        notification, setNotification,
        isLimiterActive, setIsLimiterActive,
        limiterBudget, setLimiterBudget,
        isRestoring
    };
};

export default useUIState;
// Revisado: 2025-12-16
